import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{#if @record.estimatedDurationSeconds}}\n  {{format-duration\n    @record.estimatedDurationSeconds\n    \'SECOND\'\n    (hash expectHours=true)\n  }}\n{{/if}}")